<template>
<div>
	<!-- List of Text Items -->
	<ion-grid class="ion-grid">
		<ion-row class="row m-0 px-2">
			<ion-col v-for="d in DocPinList" :key="d.docPinId" size="12" @click="ShowItemPage(d)">
				<ion-card class="card card-style m-0">
					<ion-item class="ion-item">
						<i class="fa mx-3 font-24" :class="getClassNameForPinIcon(d)"></i>
						<ion-label class="ion-label">{{d.docTitle}}</ion-label>
						<span class="float-left text-left mx-3" style="width:20%" @click.stop="deletePin(d)"><i class="fa fa-trash color-red1-dark ml-0 font-14"></i></span>
					</ion-item>
					<ion-card-content class="ion-card-content">
						{{d.description}}
					</ion-card-content>
				</ion-card>
			</ion-col>
		</ion-row>
	</ion-grid>

	<!-- List of Input Items -->
<div class="card card-style" v-if="DocPinList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">آیتمی یافت نشد.</p>
                    </div>
                </div>
</div>
</template>

<script>

	import {
		IonItem,
		IonLabel,
		IonCard,
		IonCol,
		IonGrid,
		IonRow

	} from '@ionic/vue';
	import { defineComponent } from 'vue';
	import VueSimpleAlert from 'vue3-simple-alert';

	export default defineComponent({
		components: {
			IonItem,
			IonLabel,
			IonCard,
			IonCol,
			IonGrid,
			IonRow
		},
		computed: {
			UpdateDocPinList() {
				return this.$store.getters.GetUpdateDocPinList;
			},
			DocPinList() {
				return this.$store.getters.GetDocPinList;
			},
			Loading() {
                return this.$store.getters.GetLoading;
            },

		},
		methods: {
			GetDocPinList() {
				this.$store.dispatch("GetDocPinListFromServer");
			},
			ShowItemPage(pin) {
				this.$router.push({ path: pin.docLink.replace("tsk", "").replace("TSK", "") });
			},
			getClassNameForPinIcon(d) {
				var classNsme = "";
				switch (d.baseDocId) {
					case 16:
						classNsme = "fa-list-alt color-blue1-dark";
						break;
					case 26:
						classNsme = "fa-check-square color-green1-light";
						break;
					case 28:
						classNsme = "fa-sticky-note color-pink1-dark";
						break;
					default:
						classNsme = "fa-check-square color-green1-light";
				}
				return classNsme;
			},
			deletePin(pin) {
				VueSimpleAlert.confirm(
					"آیا مایل به حذف این مورد از لیست نشان شده ها هستید؟",
					null,
					"question",
					{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
				).then(() => {
					this.$http
						.get("Docpin/Delete?id=" + pin.docPinId)
						.then((data) => {
							var res = data.data;
							if (res == "1") {
								this.showSuccessMessage("با موفقیت حذف شد.");
								this.page = 1;
								this.GetDocPinList();
							} else {
								this.showErrorMessage(res);
							}
						});
				});
			},
		},
		
		created() {
			if (this.UpdateDocPinList == true) {
				this.GetDocPinList();
			}

		},
	},

	);
</script>